module.exports = __webpack_public_path__ + "assets/img/personDone.792605cf.png";